// Maps backend Store Action categories to compact filters, labels, and theme tokens.
import { CompactStoreActionCategory } from './storeActionDomain';
import {
  OTHER_STORE_ACTION_THEME_TOKEN,
  STORE_ACTION_THEME_TOKENS,
  StoreActionThemeToken,
} from './storeActionTheme';
export interface StoreActionCategoryDefinition {
  readonly colorToken: StoreActionThemeToken;
}

export interface ResolvedStoreActionCategory
  extends StoreActionCategoryDefinition {
  readonly compactCategory: Exclude<CompactStoreActionCategory, 'ALL'>;
}

export const storeActionCategoryCatalog: Readonly<
  Partial<Record<CompactStoreActionCategory, StoreActionCategoryDefinition>>
> = {
  AGR: {
    colorToken: STORE_ACTION_THEME_TOKENS.agreement,
  },
  CUS: {
    colorToken: STORE_ACTION_THEME_TOKENS.customer,
  },
  FACTPAY: {
    colorToken: STORE_ACTION_THEME_TOKENS.initialPayment,
  },
  INV: {
    colorToken: STORE_ACTION_THEME_TOKENS.inventory,
  },
};

export const resolveStoreActionCategory = (
  storeActionCategory: string
): ResolvedStoreActionCategory => {
  const definition =
    storeActionCategoryCatalog[
      storeActionCategory as CompactStoreActionCategory
    ];

  return definition
    ? {
        ...definition,
        compactCategory: storeActionCategory as Exclude<
          CompactStoreActionCategory,
          'ALL'
        >,
      }
    : {
        compactCategory: 'OTHER',
        colorToken: OTHER_STORE_ACTION_THEME_TOKEN,
      };
};
